import { base } from "wagmi/chains";
import { createConfig, http } from "wagmi";
import { injected, walletConnect } from "wagmi/connectors";
import { PUBLIC_V2_CONFIG } from "./lib/public-v2";
import { parseWalletConnectProjectId } from "./lib/wallet-connect-config";

export const DEMO = import.meta.env.MODE === "demo";
export const chain = base;
export const publicApiOrigin = PUBLIC_V2_CONFIG.kind === "configured" ? PUBLIC_V2_CONFIG.apiOrigin : null;
export const contracts = Object.freeze({ registry: PUBLIC_V2_CONFIG.kind === "configured" ? PUBLIC_V2_CONFIG.reference.registryAddress : null });
export const explorer = "https://basescan.org";
export const scan8004 = null;
export const indexerUrl = publicApiOrigin ?? "";
export const walletConnectProjectId = parseWalletConnectProjectId(import.meta.env.VITE_WALLETCONNECT_PROJECT_ID);

// Demo builds remain read-only and never create wallet connectors.
export function createWalletConfig(demo: boolean, projectId: string | null) {
  if (demo) return undefined;
  return createConfig({
    chains: [base],
    connectors: [
      injected(),
      ...(projectId ? [walletConnect({
        projectId,
        showQrModal: true,
        metadata: {
          name: "botnet.family",
          description: "Connect a wallet to botnet.family",
          url: "https://botnet.family",
          icons: ["https://botnet.family/favicon.svg"],
        },
      })] : []),
    ],
    transports: { [base.id]: http() },
  });
}

export const wagmiConfig = createWalletConfig(DEMO, walletConnectProjectId);
